import { Loader, PageLayout } from '@bharatpe/bharat-ui';
import React, { useEffect, useState } from 'react';
import Lottie from 'lottie-react';
import Success from '../../../assets/lottie/Success.json';
import Pending from '../../../assets/lottie/Pending.json';
import Fail from '../../../assets/lottie/Failed.json';
import { TriggerNativeApiWrapper } from 'utils/nativeUpiHandler';
import { SET_ONBOARDING_REDIRECTION_PAGE, useCollectRedirection, useMandateCollectRequestData } from 'Slices';
import { customSubScribeBackButton } from 'utils/nativeSupport';
import { API_URL } from 'Services/CONSTANT';
import { useDispatch } from 'react-redux';
import Toasty from 'components/atoms/Toasty';
import history from 'utils/History';
import { sendEvent } from 'utils/Sentry';
import { logAnalyticsEvent } from 'utils/AnalyticsEvent';
import { isEmpty } from 'utils/Utils';

const style = {
	height: 200,
	witdh: 200,
};

const CollectRequestStatus = () => {
	const [count, setCount] = useState(0);
	const dispatch = useDispatch();
	const [status, setStatus] = useState<string>('');
	const mandateCreatedDetails = useMandateCollectRequestData();
	const [loading, setLoading] = useState(true);
	const redirectionRoute = useCollectRedirection();

	const redirectToSource = () => {
		history.push({ pathname: redirectionRoute });
	};
	useEffect(() => {
		customSubScribeBackButton(() => {
			return;
		});
	}, [history]);

	useEffect(() => {
		pollApi();
	}, [count]);

	const fetchStatus: any = async () => {
		try {
			const data: any = await TriggerNativeApiWrapper(
				`${API_URL.transaction_details}/${mandateCreatedDetails?.transaction_id}`,
				'GET',
				{},
				{},
			);
			if (data?.response_code === 'ZM') {
				history.push({ pathname: '/upi/collect-auto-pay-details', search: '?wrong-pin=true' });
				return;
			}
			setLoading(false);
			return data;
		} catch (err: any) {
			Toasty.error(err?.error || 'something went wrong');
			sendEvent(err);
		}
	};

	const statusLottie = (status: string) => {
		switch (status) {
			case 'SUCCESS':
				return Success;
			case 'PENDING':
				return Pending;
			case 'FAILED':
				return Fail;
			default:
				return Pending;
		}
	};

	const statusMsg = (status: string) => {
		switch (status) {
			case 'SUCCESS':
				return 'Transaction successful';
			case 'PENDING':
				return 'Transaction pending';
			case 'FAILED':
				return 'Transaction failed';
			default:
				return 'Transaction pending';
		}
	};

	const pollApi = async () => {
		if (count > 20) {
			setStatus('FAILED');
			setTimeout(() => {
				redirectToSource();
			}, 3000);
			return;
		}
		try {
			const data = await fetchStatus();
			if (isEmpty(data)) return;
			if (data?.status == 'SUCCESS') {
				setStatus('SUCCESS');
				logAnalyticsEvent({
					trigger_point: 'Page view',
					Product: 'AutoPayUPI',
					Flow: 'SetupUPI',
					Screen: 'Success',
					Module: 'Page',
					Action: 'View',
				});
				dispatch(SET_ONBOARDING_REDIRECTION_PAGE({}));
				setTimeout(() => {
					redirectToSource();
				}, 3000);
				return;
			} else if (data?.status == 'PENDING' || data?.status == 'INITIATED') {
				setStatus('PENDING');
				setTimeout(() => {
					setCount((prev) => prev + 1);
				}, 3000);
				return;
			} else {
				dispatch(SET_ONBOARDING_REDIRECTION_PAGE({}));
				setStatus('FAILED');
				setTimeout(() => {
					redirectToSource();
				}, 3000);
			}
		} catch (error) {
			setStatus('FAILED');
			setTimeout(() => {
				redirectToSource();
			}, 3000);
			return;
		}
	};

	if (loading) return <Loader loading />;
	return (
		<PageLayout>
			<div className="absolute-center width-100">
				<Lottie animationData={statusLottie(status)} loop={true} style={style} className="content-center" />
				<p className="logo-green SemiBold500 content-center">{statusMsg(status)}</p>
			</div>
		</PageLayout>
	);
};

export default CollectRequestStatus;
